import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import ArticleList from '../components/ArticleList.vue'
import ArticleDetail from '../components/ArticleDetail.vue'
import ChatUser from '../components/ChatUser.vue'
import Index from '../pages/Index.vue'
import Article from '../pages/Article.vue'
import Chat from '../pages/Chat.vue'
import ChatGPT from '../pages/ChatGPT.vue'
import Media from '../pages/Media.vue'

import Music from '../components/media/Music.vue'
import Video from '../components/media/Video.vue'

import Language from '../pages/other/Language.vue'
import Program from '../pages/other/Program.vue'
import Algorithm from '../pages/other/Algorithm.vue'
import Blog from '../pages/other/Blog.vue'

import Login from '../pages/login.vue'
import Register from '../pages/register.vue'

import UserRoom from '../pages/userroom/userRoom.vue'
import Search from '../pages/Search.vue'
import Favorite from '../pages/userroom/Favorite.vue'
import Comment from '../pages/userroom/Comment.vue'
import Message from '../pages/userroom/Message.vue'
import SysNoticeList from '../pages/userroom/SysNoticeList.vue'
import ReplyList from '../pages/userroom/ReplyList.vue'

import page404 from '../views/pages/404.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // meta: {
    //    title: '编程知识学习'
    // },
    children:[
        {
            path: '/',
            name: '首页',
            component: Index,
            meta: {
                title: '编程知识学习'
            }
        },
        {
            path: '/index',
            name: '首页',
            component: Index,
            meta: {
                title: '编程知识学习'
            }
        },
        {
            path: '/article/rootColumn/:rootColumnId',
            name: '文章',
            component: Article,
            meta: {
                title: '文章-编程知识学习'
            },
            children: [
                {
                    path: '/article/rootColumn/:rootColumnId',
                    component: (resolve) => require(['@/pages/RootColumn'], resolve),
                    name: 'rootColumn',
                    meta: {
                        title: '文章-编程知识学习'
                    },
                },
                {
                    path: '/article/articleDetail/:articleId',
                    name: 'articleDetail',
                    component: ArticleDetail,
                    meta: {
                        title: '文章-编程知识学习'
                    },
                },
            ]
        },
        {
            path: '/chat',
            name: '聊天',
            component: Chat,
            children: [
                {
                    path: '/chat/:friendId',
                    name: '用户聊天页面',
                    component: ChatUser,
                },
            ]
        },
        {
            path: '/chatGPT',
            name: 'chatGPT',
            component: ChatGPT,
        },
        {
            path: '/media',
            name: '媒体',
            component: Media,
            children: [
                {
                    path: '/media',
                    name: '音乐',
                    component: Music,
                },
                {
                    path: '/media/music',
                    name: '音乐',
                    component: Music,
                },
                {
                    path: '/media/video',
                    name: '视频',
                    component: Video
                },


            ]
        },

        {
            path: '/login',
            name: '登录',
            component: Login
        },
        {
            path: '/register',
            name: '注册',
            component: Register
        },

        {
            path: '/user/room',
            name: '个人中心',
            component: UserRoom
        },

        {
            path: '/search/:keyword',
            name: '搜索结果',
            component: Search
        },

        {
            path: '/favorite',
            name: '我的收藏',
            component: Favorite
        },

        {
            path: '/comment',
            name: '我的评论',
            component: Comment
        },

        {
            path: '/message',
            name: '我的消息',
            component: Message,
            children: [
                {
                    path: '/',
                    name: '系统通知',
                    component: SysNoticeList
                },
                {
                    path: '/sysNotice',
                    name: '系统通知',
                    component: SysNoticeList
                },
                {
                    path: '/reply',
                    name: '系统通知',
                    component: ReplyList
                },
            ]
        },


        {
            path: '/language',
            name: '编程语言',
            component: Language
        },
        {
            path: '/program',
            name: '软件工程',
            component: Program
        },
        {
            path: '/algorithm',
            name: '算法',
            component: Algorithm
        },
        {
            path: '/blog',
            name: '博客',
            component: Blog
        },
    ]
  },

  {
      path: "/404",
      name: "notFound",
      component: page404,
      meta: {
          title: '404 Page'
      }
  }, {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
